import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to unlock your space's potential?
          </h2>
          <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto">
            Join thousands of Australians earning extra income by sharing their unused spaces with stashly
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/become-host"
              className="px-10 py-4 bg-white text-blue-600 font-semibold rounded-xl hover:bg-gray-50 transition-colors shadow-lg cursor-pointer whitespace-nowrap text-lg"
            >
              <i className="ri-add-circle-line mr-2"></i>
              Start Earning Today
            </Link>
            <Link
              to="/browse"
              className="px-10 py-4 bg-blue-500 text-white font-semibold rounded-xl hover:bg-blue-400 transition-colors shadow-lg cursor-pointer whitespace-nowrap text-lg border-2 border-white"
            >
              <i className="ri-search-2-line mr-2"></i>
              Browse Spaces
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
